import { useState } from 'react';
import { Collapse, Flex } from 'antd';
import { SearchBox, useHits } from 'react-instantsearch';
import { DownOutlined } from '@ant-design/icons';
import '../SearchBox/SearchBox.css';
import SearchIcon from '../../assets/icon-search-outline.svg';
import { useTranslation } from 'react-i18next';
import '../../i18n';
import '../../local';
import CustomMenu from '../CustomRefinmentList/CustomMenu';
import ReactMarkdown from 'react-markdown';

const CustomSearch = () => {
  const { t } = useTranslation();

  const transformItems = (items: any[]) => {
    const questionsAndAnswers: any[] = [];

    items.forEach((item: any) => {
      if (item.question && item.question[0] && item.answer) {
        questionsAndAnswers.push({
          question: item.question[0],
          answer: item.answer,
        });
      }
    });

    return questionsAndAnswers;
  };

  const hitsApi = useHits();
  const questionsAndAnswers = transformItems(hitsApi.hits);

  const [visibleQuestions, setVisibleQuestions] = useState(5);

  const showMoreQuestions = () => {
    setVisibleQuestions(prev => prev + 5);
  };

  const noResults = hitsApi.hits.length === 0;

  const collapseItems = questionsAndAnswers
    .slice(0, visibleQuestions)
    .map((qa: any, index: number) => ({
      key: index.toString(),
      label: (
        <div className="questions-continer">
          {qa.question}
        </div>
      ),
      children: (
        <ul>
          {Array.isArray(qa.answer) ? (
            qa.answer.map((item: any, subIndex: number) => (
              <li
                className="answers-container"
                key={subIndex.toString()}
              >
                <ReactMarkdown>
                  {item}
                </ReactMarkdown>
              </li>
            ))
          ) : (
            <ReactMarkdown>
              {qa.answer}
            </ReactMarkdown>
          )}
        </ul>
      ),
    }));

  return (
    <div className="page-continer">
      <Flex wrap="wrap" gap="small">
        <div className="input-container">
          <SearchBox
            placeholder={t('Start_searching_for_any_question')}
            submitIconComponent={({ classNames }) => (
              <div className={classNames.submitIcon}>
                <img alt="searchIcon" src={SearchIcon} />
              </div>
            )}
          />
        </div>
      </Flex>

      <CustomMenu attribute="QuestionCategory" />

      {noResults ? (
        <p className="noResultsClass">
          {t('No_search_results_found')}
        </p>
      ) : (
        <div className="qaAnswerContainer">
          <Collapse
            ghost
            items={collapseItems}
            expandIconPosition="end"
            expandIcon={({ isActive }) => (
              <DownOutlined
                className="downArrow"
                style={{ transition: 'none' }}
                rotate={isActive ? 0 : 180}
              />
            )}
          />
        </div>
      )}

      {visibleQuestions < questionsAndAnswers.length && (
        <div className="showMoreBtn-continer">
          <div
            className="showMoreBtn"
            onClick={showMoreQuestions}
          >
            {t('Load_More')}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomSearch;
